export default __webpack_public_path__ + "static/media/error.cee5d4d5.svg";